import type { FC } from "react";
import { Col, Container, Row } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { NumberElement } from "src/website-apps/shared/components/branding";
import {
  MetricsBackground,
  MetricsDisclaimer,
  MetricsTitle,
} from "src/website-apps/shared/components/branding/styled-components";

export const MetricsBanner: FC = () => (
  <MetricsBackground>
    <Container
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        paddingTop: "50px",
        paddingBottom: "20px",
      }}
    >
      <Row center={[true]}>
        <Col>
          <MetricsTitle>
            <Content id="cid$#1906966#" />
          </MetricsTitle>
        </Col>
      </Row>
      <Row>
        <NumberElement number="62%" message={<Content id="cid$#1906963#" />} />
        <NumberElement number="75%" message={<Content id="cid$#1906964#" />} />
        <NumberElement number="53%" message={<Content id="cid$#1906965#" />} />
      </Row>
      <Row center={[true]}>
        <MetricsDisclaimer>
          <Content id="cid$#1906967#" />
        </MetricsDisclaimer>
      </Row>
    </Container>
  </MetricsBackground>
);
